import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CtaButton from 'components/essentials/Cta/CtaButton';

const CheckoutSubmitButton = ({
  block = false,
  children,
  className = '',
  dataXc,
  disabled = false,
  id = '',
  isInSidebarModal = false,
  isLoading = false,
  onClick,
}) => (
  <CtaButton
    data-xc={dataXc}
    styling="solid-button"
    color="black"
    type="submit"
    disabled={disabled}
    block={block}
    onClick={onClick}
    className={classNames(
      `w-full text-white md:w-auto disabled:bg-gray-light5 disabled:text-gray-light2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`,
      {
        'md:min-w-[350px]': !isInSidebarModal,
        'md:w-full': isInSidebarModal,
      }
    )}
    id={id}
    isLoading={isLoading}
  >
    {children}
  </CtaButton>
);

CheckoutSubmitButton.propTypes = {
  block: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  dataXc: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isInSidebarModal: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CheckoutSubmitButton;
